<router-outlet></router-outlet>
<svg class="transition duration-300 ease-in-out delay-150" id="svg" viewBox="0 0 1440 465"
     xmlns="http://www.w3.org/2000/svg">
    <style>
        .path-0 {
            animation: pathAnim-0 15s;
            animation-timing-function: linear;
            animation-iteration-count: infinite;
            animation-direction: alternate;
        }

        @keyframes pathAnim-0 {
            0% {
                d: path("M335.5 16.5C242.5 16.5 195.668 162.832 95.5 168.5C81.6585 169.283 0 168.5 0 168.5V620H1440V64.5987H1392.53C1310.5 64.5987 1275.43 146 1172.5 146C1069.57 146 1015 0 897.743 0C780.486 0 659.651 199.099 566.5 199.099C473.349 199.099 428.5 16.5 335.5 16.5Z");

            }
            100% {
                d: path("M348.318 131.5C225.318 131.5 207.766 31 107.5 31C37.5 31 0 87.2179 0 87.2179V594H1440V121.717H1392.53C1310.5 121.717 1297.5 47.2179 1208.5 47.2179C1119.5 47.2179 1042 175 947.5 175C853 175 748.5 0 629.5 0C510.5 0 516.318 131.5 348.318 131.5Z");

            }
        }</style>
    <path class="path-0"
          d="M348.318 131.5C225.318 131.5 207.766 31 107.5 31C37.5 31 0 87.2179 0 87.2179V594H1440V121.717H1392.53C1310.5 121.717 1297.5 47.2179 1208.5 47.2179C1119.5 47.2179 1042 175 947.5 175C853 175 748.5 0 629.5 0C510.5 0 516.318 131.5 348.318 131.5Z"
          fill="url(#paint0_linear_1615_39466)"
          opacity="0.5"/>
    <defs>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_1615_39466" x1="720" x2="720" y1="80.3057"
                        y2="594">
            <stop offset="0" stop-color="#00B858"/>
            <stop offset="1" stop-color="#5378C2" stop-opacity="0"/>
        </linearGradient>
    </defs>
    <style>
        .path-1 {
            animation: pathAnim-1 15s;
            animation-timing-function: linear;
            animation-iteration-count: infinite;
            animation-direction: alternate;
        }

        @keyframes pathAnim-1 {
            0% {
                d: path("M348.318 131.5C225.318 131.5 207.766 31 107.5 31C37.5 31 0 87.2179 0 87.2179V594H1440V121.717H1392.53C1310.5 121.717 1297.5 47.2179 1208.5 47.2179C1119.5 47.2179 1042 175 947.5 175C853 175 748.5 0 629.5 0C510.5 0 516.318 131.5 348.318 131.5Z");
            }
            100% {
                d: path("M335.5 16.5C242.5 16.5 195.668 162.832 95.5 168.5C81.6585 169.283 0 168.5 0 168.5V620H1440V64.5987H1392.53C1310.5 64.5987 1275.43 146 1172.5 146C1069.57 146 1015 0 897.743 0C780.486 0 659.651 199.099 566.5 199.099C473.349 199.099 428.5 16.5 335.5 16.5Z");
            }
        }</style>
    <path class="path-1"
          d="M335.5 16.5C242.5 16.5 195.668 162.832 95.5 168.5C81.6585 169.283 0 168.5 0 168.5V620H1440V64.5987H1392.53C1310.5 64.5987 1275.43 146 1172.5 146C1069.57 146 1015 0 897.743 0C780.486 0 659.651 199.099 566.5 199.099C473.349 199.099 428.5 16.5 335.5 16.5Z"
          fill="url(#paint0_linear_1615_39465)"/>
    <defs>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_1615_39465" x1="720" x2="720" y1="-40"
                        y2="620">
            <stop offset="0" stop-color="#00B858"/>
            <stop offset="1" stop-color="#5378C2" stop-opacity="0"/>
        </linearGradient>
    </defs>
</svg>
